"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const Transporter_1 = __importDefault(require("../../atoms/Transporter"));
const Paths_1 = require("../../constants/Paths");
const DataLayerActions_1 = __importDefault(require("../../enums/DataLayerActions"));
const DataLayerEvents_1 = __importDefault(require("../../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const dataLayer_1 = require("../../helper/dataLayer");
const history_1 = require("../../helper/history");
const order_1 = require("../../helper/order");
const path_1 = require("../../helper/path");
const ShopwareOrder_1 = __importDefault(require("../../stores/ShopwareOrder"));
const ShopCheckoutConfirmation = (location) => {
    const orderId = location.match?.params?.orderId;
    const [order, setOrder] = react_1.default.useState(null);
    (0, react_1.useEffect)(() => {
        if (!orderId) {
            (0, history_1.pushHistory)(location.history, Paths_1.PATH_SHOP_CART);
            return;
        }
        ShopwareOrder_1.default.loadOrder(orderId).then((loadedOrder) => {
            setOrder(loadedOrder);
            (0, dataLayer_1.pushToDataLayer)({
                action: DataLayerActions_1.default.checkoutProgress,
                [DataLayerLabels_1.default.eventLabel]: (0, translation_1.t)('shop_checkout_page.stepper.confirmation'),
            });
            pushOrderInEventToDataLayer(loadedOrder ?? undefined);
            return;
        });
    }, [orderId]);
    if (!order) {
        return (react_1.default.createElement("section", { className: "znd-shop-checkout-page__wrapper" },
            react_1.default.createElement("section", { className: "znd-shop-confirmation-page__content" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true }))));
    }
    const orderType = order?.customFields?.massiveOrderType ?? ecommerce_1.OrderCustomFieldsMassiveOrderTypeEnum.Order;
    const description = (0, translation_1.t)(`shop_checkout_confirmation_page.${orderType}.description`, {
        email: order?.orderCustomer?.email,
        channel: AuthorizationStore_1.default.channelId,
    });
    const advancePaymentText = (0, translation_1.t)('payment.advance_payment.text', {
        channel: AuthorizationStore_1.default.channelId,
        reference: order?.customFields?.zkpSoftwareOfferId ?? order?.orderNumber ?? null,
    });
    const showAdvancePaymentText = true === order?.customFields?.massiveIsAdvancePayment && !!advancePaymentText;
    return (react_1.default.createElement("section", { className: "znd-shop-checkout-page__wrapper" },
        react_1.default.createElement("header", { className: "znd-shop-checkout-page__header" },
            react_1.default.createElement("h1", { className: "znd-shop-checkout-page__title" }, (0, translation_1.t)(`shop_checkout_confirmation_page.${orderType}.title`, { channel: AuthorizationStore_1.default.channelId }))),
        react_1.default.createElement("section", { className: "znd-shop-confirmation-page__content" },
            react_1.default.createElement("h2", { className: "znd-shop-confirmation-page__title" }, (0, translation_1.t)(`shop_checkout_confirmation_page.${orderType}.text`, { channel: AuthorizationStore_1.default.channelId })),
            react_1.default.createElement("p", { className: "znd-shop-confirmation-page__description", dangerouslySetInnerHTML: { __html: description } }),
            showAdvancePaymentText ? (react_1.default.createElement("p", { className: "znd-shop-confirmation-page__description", dangerouslySetInnerHTML: { __html: advancePaymentText } })) : null,
            react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(Paths_1.PATH_SHOP), className: "znd-shop-confirmation-page__back" },
                react_1.default.createElement(Button_1.default, { className: "btn-block justify-content-center text-nowrap", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('shop_checkout_confirmation_page.back') })),
            react_1.default.createElement("footer", { className: "znd-shop-confirmation-page__animation" },
                react_1.default.createElement("div", { className: "znd-shop-confirmation-page__animation-city" }),
                react_1.default.createElement("div", { className: "znd-shop-confirmation-page__animation-city" }),
                react_1.default.createElement("div", { className: "znd-shop-confirmation-page__animation-city" }),
                react_1.default.createElement("div", { className: "znd-shop-confirmation-page__animation-city" }),
                react_1.default.createElement(Transporter_1.default, { className: "znd-shop-confirmation-page__animation-car" })))));
};
const pushOrderInEventToDataLayer = (order) => {
    const productLineItems = order?.lineItems?.filter((lineItem) => lineItem.type === ecommerce_1.LineItemTypeEnum.Product);
    const orderItems = productLineItems?.map((lineItem) => ({
        item_id: lineItem.payload?.productNumber ?? undefined,
        item_name: lineItem.label ?? undefined,
        quantity: lineItem.quantity ?? undefined,
        price: lineItem.unitPrice ?? undefined,
    }));
    // Clear the previous ecommerce object
    (0, dataLayer_1.pushToDataLayer)({ [DataLayerLabels_1.default.dlvEcommerce]: null });
    // Send a new ecommerce object
    (0, dataLayer_1.pushToDataLayer)({
        event: DataLayerEvents_1.default.dlvPurchase,
        [DataLayerLabels_1.default.dlvEcommerce]: {
            transaction_id: order?.orderNumber,
            value: order?.price?.totalPrice,
            tax: (0, order_1.calculateTaxes)(order ?? undefined) ?? undefined,
            shipping: order?.shippingCosts?.totalPrice,
            currency: order?.currency?.isoCode,
            coupon: order?.currency?.isoCode,
            items: orderItems,
        },
    });
};
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)((0, react_router_dom_1.withRouter)(ShopCheckoutConfirmation)));
